/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../services/common.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-delete-report-modal',
  templateUrl: './delete-report-modal.component.html',
  styleUrls: ['./delete-report-modal.component.scss']
})
export class DeleteReportModalComponent implements OnInit {
  @Input() selectedReport: any; // Receiving the report as input
  public closeModal: Subject<any>;

  constructor(public modalRef: BsModalRef, private commonService: CommonService) {
    this.closeModal = new Subject();
  }

  ngOnInit() {
    this.selectedReport = JSON.parse(JSON.stringify(this.commonService.getSelectedReport()));
    this.commonService.setSelectedReport({});
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  public closeModalWindow() {
    this.closeModal.next({ delete: false }); // Emit false when cancelled
    this.modalRef.hide();
  }

  public confirmDeletion() {
    this.closeModal.next({ delete: true, report: this.selectedReport }); // Emit data when confirmed
    this.modalRef.hide();
  }
}
